'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetch = fetch;
exports.post = post;
exports.patch = patch;
exports.put = put;

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _elementUi = require('element-ui');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_axios2.default.defaults.timeout = 5000;
_axios2.default.defaults.baseURL = 'http://jxxht.com.cn/api/';

//http request 拦截器
_axios2.default.interceptors.request.use(function (config) {
  // const token = getCookie('名称');注意使用的时候需要引入cookie方法，推荐js-cookie
  config.data = JSON.stringify(config.data);
  config.headers = {
    'Content-Type': 'application/x-www-form-urlencoded'
  };
  // if(token){
  //   config.params = {'token':token}
  // }
  return config;
}, function (error) {
  return Promise.reject(err);
});

//http response 拦截器
_axios2.default.interceptors.response.use(function (response) {
  if (response.data.errCode == 2) {
    router.push({
      path: "/login",
      query: {
        redirect: router.currentRoute.fullPath
      } //从哪个页面跳转
    });
  }
  return response;
}, function (error) {
  return Promise.reject(error);
});

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

function fetch(url) {
  var params = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  return new Promise(function (resolve, reject) {
    _axios2.default.get(url, {
      params: params
    }).then(function (response) {
      resolve(response.data);
    }).catch(function (err) {
      reject(err);
    });
  });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

function post(url) {
  var data = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  return new Promise(function (resolve, reject) {
    _axios2.default.post(url, data).then(function (response) {
      resolve(response.data);
    }, function (err) {
      reject(err);
    });
  });
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

function patch(url) {
  var data = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  return new Promise(function (resolve, reject) {
    _axios2.default.patch(url, data).then(function (response) {
      resolve(response.data);
    }, function (err) {
      reject(err);
    });
  });
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

function put(url) {
  var data = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  return new Promise(function (resolve, reject) {
    _axios2.default.put(url, data).then(function (response) {
      resolve(response.data);
    }, function (err) {
      reject(err);
    });
  });
}


// WEBPACK FOOTER //
// ./src/https/index.js